import { action } from 'easy-peasy';
import { IActionSetUser } from '../types';

const setUser: IActionSetUser = action((state, payload) => {
  state.item = payload;
});

export default setUser;
